/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoadCMASubjectPropertyImagesOutput
 */
export interface LoadCMASubjectPropertyImagesOutput {
    /**
     * 
     * @type {boolean}
     * @memberof LoadCMASubjectPropertyImagesOutput
     */
    replaced: boolean;
}

/**
 * Check if a given object implements the LoadCMASubjectPropertyImagesOutput interface.
 */
export function instanceOfLoadCMASubjectPropertyImagesOutput(value: object): value is LoadCMASubjectPropertyImagesOutput {
    if (!('replaced' in value) || value['replaced'] === undefined) return false;
    return true;
}

export function LoadCMASubjectPropertyImagesOutputFromJSON(json: any): LoadCMASubjectPropertyImagesOutput {
    return LoadCMASubjectPropertyImagesOutputFromJSONTyped(json, false);
}

export function LoadCMASubjectPropertyImagesOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoadCMASubjectPropertyImagesOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'replaced': json['replaced'],
    };
}

export function LoadCMASubjectPropertyImagesOutputToJSON(json: any): LoadCMASubjectPropertyImagesOutput {
    return LoadCMASubjectPropertyImagesOutputToJSONTyped(json, false);
}

export function LoadCMASubjectPropertyImagesOutputToJSONTyped(value?: LoadCMASubjectPropertyImagesOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'replaced': value['replaced'],
    };
}

